// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1rjC2","rootSuccess":"CompleteLink_rootSuccess__2fMMA","rootFailure":"CompleteLink_rootFailure__36gjY","isDisabled":"CompleteLink_isDisabled__ZJcbs"};